import LabelMap from "../../../bootstrap/types/label-map/LabelMap";
import __ from '../../i18n';


const PLACE_HOME_HEADER = 'HOME_HEADER';
const PLACE_HOME_MIDDLE = 'HOME_MIDDLE';
const PLACE_HOME_BOTTOM = 'HOME_BOTTOM';
const PLACE_ABOUT_HEADER = 'ABOUT_HEADER';


const places = new LabelMap([
    [PLACE_HOME_HEADER, __('Home header')],
    [PLACE_HOME_MIDDLE, __('Home middle')],
    [PLACE_HOME_BOTTOM, __('Home bottom')],
    [PLACE_ABOUT_HEADER, __('About header')],
]);

export default places;

export {
    PLACE_HOME_HEADER,
    PLACE_HOME_MIDDLE,
    PLACE_HOME_BOTTOM,
    PLACE_ABOUT_HEADER,
};